<template>
  <div class="member-search">
    <!-- 화면 타이틀 -->
<!--    <v-card elevation="0" fixed tile>-->
<!--      <v-app-bar flat color="rgb(255, 255, 255)">-->
<!--        <v-toolbar-title class="pl-0 header-area">-->
<!--          <v-btn fab text x-small color="black" @click="goBack">-->
<!--            <v-icon size="24">mdi-arrow-left</v-icon>-->
<!--          </v-btn>-->
<!--          <span class="align-self-center header-title">직원찾기</span>-->
<!--        </v-toolbar-title>-->
<!--        <v-spacer />-->
<!--      </v-app-bar>-->
<!--    </v-card>-->
    <!--v-row class="title-wrap" fixed>
      <v-col cols="12" class="pa-4 search-header">
        <v-btn fab text x-small color="black" @click="goBack">
          <v-icon size="24">mdi-arrow-left</v-icon>
        </v-btn>
        <span class="search-title">직원찾기</span>
      </v-col>
    </v-row-->
    <!-- tab -->
    <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
      <v-tab>직원검색</v-tab>
<!--      <v-tab>조직도</v-tab>-->
    </v-tabs>

    <!-- tab contents -->
    <v-tabs-items v-model="tab" touchless>
      <!-- [tab1] 직원검색 ============================================================ -->
      <v-tab-item class="pb-16">
        <!-- 1-1. 검색영역 -->
        <search-text-field
          v-bind:placeholderMsg="'직원을 검색해주세요.'"
          v-on:setSearchParam="fetchMemberSearchList"
          v-on:initSearchParam="clearTab1"
        ></search-text-field>

        <!-- 1-2-A. empty Data component -->
        <empty-data v-if="emptyDataFlag1"></empty-data>

        <!-- 1-2-B. 직원정보목록 -->
        <member-search-list
          v-else
          v-bind:searchList="memberSearchList"
          v-on:clickMemberItem="openModal"
          class="overflow-y-auto"
        ></member-search-list>
      </v-tab-item>

      <!-- [tab2] 조직도 ============================================================ -->
      <v-tab-item class="pb-16">
        <!-- 2-1. 검색영역 -->
        <search-text-field
          v-bind:placeholderMsg="'조직도명을 검색해주세요.'"
          v-on:setSearchParam="fetchOrgInfoList"
          v-on:initSearchParam="clearTab2"
        ></search-text-field>

        <!-- 2-2-A. empty Data component-->
        <empty-data v-if="emptyDataFlag2"></empty-data>

        <!-- 2-2-B. 일부조직도(조직목록선택시, treeview)-->
        <org-tree-list
          v-else-if="orgTreeList.length > 0"
          v-bind:searchList="orgTreeList"
          class="overflow-y-auto"
          v-on:clickMemberItem="openModal"
        ></org-tree-list>

        <!-- 2-2-C. 조직정보목록 -->
        <org-info-list
          v-else-if="orgInfoList.length > 0"
          v-bind:searchList="orgInfoList"
          v-on:selectItem="fetchOrgInfoTreeList"
        ></org-info-list>

        <!-- 2-2-D. 전체조직도(treeview)-->
        <org-tree-list
          v-else
          v-bind:searchList="allOrgTreeList"
          v-on:clickMemberItem="openModal"
        ></org-tree-list>
      </v-tab-item>
    </v-tabs-items>

    <!---------------------------------------------------------------------------->
    <!-- [모달] 직원프로필  -->
    <member-profile-dialog v-bind:memberInfo="selectMemberObj" />
  </div>
</template>

<script>
/* 직원찾기 */
import EmptyData from '@/components/common/EmptyData.vue';
import SearchTextField from '@/components/member/SearchTextField.vue';
import MemberSearchList from '@/components/member/MemberSearchList.vue';
import orgInfoList from '@/components/org/orgInfoList.vue';
import orgTreeList from '@/components/org/orgTreeList.vue';
import MemberProfileDialog from '@/components/member/dialog/MemberProfileDialog.vue';
import { getMemberSearchList } from '@/api/member.js';
import { getOrgInfoTreeList, getOrgInfoList } from '@/api/org';
import routerConstants from '@/const/routerConstants';

export default {
  data: () => ({
    tab: null,
    selectMemberObj: {}, // 직원프로필 모달 전달용

    // [tab1]
    emptyDataFlag1: false, // 조회결과없음 플래그1
    memberSearchList: [], // 직원정보목록(검색목록)

    // [tab2]
    emptyDataFlag2: false, // 조회결과없음 플래그2
    orgInfoList: [], // 조직도정보목록(검색목록)
    orgTreeList: [], // 조직도트리목록(검색선택)
    allOrgTreeList: [], // 전체 조직도트리목록
    allMemberSearchList: [], // 전체 직원정보목록
  }),

  watch: {
    tab() {
      // 조직도 탭 처음 클릭시
      if (this.tab === 1 && this.allMemberSearchList.length < 1) {
        // 공통 스피너 ON
        this.$store.commit('SPINNER/ON_COMMON_SPINNER');
        // 직원정보목록조회 호출 (전체조회)
        this.fetchMemberSearchList('');
      }
    },
  },

  computed: {
  },

  beforeCreate() {
    this.$store.commit('DIALOG/INIT_MODAL', 'member_profile');
  },

  methods: {
    goBack() {
      this.$router.push({ name: routerConstants.Main });
      //this.$router.go(-1);
    },
    /* [common] ====================================================================== */
    /* 모달오픈 */
    openModal(param) {
      this.selectMemberObj = param;
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'member_profile'); // 직원프로필 모달
    },

    /* [tab1] ====================================================================== */
    /* 직원검색탭 초기화 (검색영역 클리어버튼 클릭) */
    clearTab1() {
      this.memberSearchList = [];
      this.emptyDataFlag1 = false;
    },

    /* [tab2] ====================================================================== */
    /* 조직도탭 초기화 (검색영역 클리어버튼 클릭) */
    clearTab2() {
      this.orgInfoList = [];
      this.orgTreeList = [];
      this.emptyDataFlag2 = false;
    },

    /* 트리뷰형태 데이터 변환 */
    convertTreeData(searchList) {
      let orgMap = {},
        empList = [],
        node,
        resultList = [];

      // 1. 조직코드를 키로 index값을 담는 map 생성 (orgMap)
      searchList.forEach((org, index) => {
        orgMap[org.orgCd] = index;

        // 2. children 컬럼 초기화
        empList = this.allMemberSearchList.filter(
          emp => emp.orgCd === org.orgCd,
        );

        org.children = [];
        if (empList.length > 0) {
          org.children = empList; // 조직원이 있다면 인사정보리스트 세팅
        } else {
          org.children = [
            {
              emptyFlag: true,
            },
          ]; // 조직원이 없다면 일단 '비어있음'플래그 추가
        }
      });

      // 3. children 세팅으로 조직간 상하위 연결
      for (var i = 0; i < searchList.length; i += 1) {
        node = searchList[i]; // 현재 node 데이터 저장

        // 전체조회시 ? 상위조직코드가 '0'이면 최상위조직
        // 조직목록선택조회시 ? 특정 조직을 선택하여 조회한 결과이므로 최상위조직은 rownum=1인 것(1건)
        if (node.priorOrgCd == '00' || i == 0) {
          resultList.push(node); // 최상위 조직인 경우 반환변수에 push
        } else {
          if (searchList[orgMap[node.priorOrgCd]].children[0].emptyFlag) {
            searchList[orgMap[node.priorOrgCd]].children.shift(); // 하위 조직이 있으면 default값 삭제
          }

          searchList[orgMap[node.priorOrgCd]].children.push(node); // 현재 노드의 상위조직코드의 행을 찾아서 현재 노드를 push
        }
      }

      // 4. 공통 스피너 OFF
      this.$store.commit('SPINNER/OFF_COMMON_SPINNER');

      // 5. 변환값 반환
      return resultList;
    },

    /* API ====================================================================== */
    /* 직원검색 목록조회 */
    async fetchMemberSearchList(searchEmpName) {
      try {
        // 1. API 호출
        const response = await getMemberSearchList({
          searchEmpName,
        });
        const dataList = response.data.data;

        // 2-A. 직원검색탭에서 조회시
        if (this.tab === 0) {
          // 2-A-1. 조회결과 세팅
          this.memberSearchList = [];
          if (dataList.length > 0) this.memberSearchList = dataList;

          // 2-A-2. 조회결과없음 플래그값 세팅
          this.emptyDataFlag1 = this.memberSearchList.length < 1;

          // 2-A-3. 공통 스피너 OFF
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        } else {
          // 2-B. 조직도탭에서 조회시
          if (dataList.length > 0) {
            // 2-B-1. 조회결과 세팅
            this.allMemberSearchList = dataList;

            // 2-B-2. 조직정보 트리목록조회 호출
            this.fetchOrgInfoTreeList();
          }
        }
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },

    /* 조직정보 목록조회 */
    async fetchOrgInfoList(searchOrgName) {
      try {
        // 1. API호출
        const response = await getOrgInfoList({
          searchOrgName,
        });
        const dataList = response.data.data;

        // 2. 조회결과 세팅
        this.orgTreeList = []; // 조직검색트리 초기화
        this.orgInfoList = [];
        if (dataList.length > 0) {
          this.orgInfoList = dataList;
        }

        // 3. 조회결과없음 플래그값 세팅
        this.emptyDataFlag2 = this.orgInfoList.length < 1;

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
      }
    },

    /* 조직정보 트리목록조회 */
    async fetchOrgInfoTreeList(param) {
      try {
        // 1. API호출
        const response = await getOrgInfoTreeList(param);
        const dataList = response.data.data;

        if (dataList.length > 0) {
          // 2. 파라미터값이 없으면 allOrgTreeList에 담기(전체조회 데이터)
          if (param !== undefined) {
            this.orgTreeList = this.convertTreeData(dataList);
          } else {
            this.allOrgTreeList = this.convertTreeData(dataList);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  components: {
    EmptyData,
    SearchTextField,
    MemberSearchList,
    orgInfoList,
    orgTreeList,
    MemberProfileDialog,
  },
};
</script>

<style>
/* _memberSearch.scss 참고 */
</style>
